import PropTypes from "prop-types";
import React, { useCallback, useRef } from "react";
import { Animated, Pressable } from "react-native";

export default function PressableContainer(props) {
  const {
    rootStyle = {},
    additionalTransforms = [],
    accessibilityLabel,
    accessibilityRole = "button",
    shouldPress = true,
    style,
    onPress,
    disabled,
    children,
  } = props;

  const animatedScale = useRef(new Animated.Value(1)).current;

  const popIn = useCallback(() => {
    Animated.timing(animatedScale, {
      toValue: 0.98,
      duration: 50,
      useNativeDriver: true,
    }).start();
  }, [animatedScale]);

  const popOut = useCallback(() => {
    Animated.timing(animatedScale, {
      toValue: 1,
      duration: 100,
      useNativeDriver: true,
    }).start();
  }, [animatedScale]);

  return (
    <Animated.View
      style={{
        ...rootStyle,
        transform: [
          { scale: shouldPress ? animatedScale : 1 },
          ...additionalTransforms,
        ],
      }}
    >
      <Pressable
        accessibilityRole={accessibilityRole}
        accessibilityLabel={accessibilityLabel}
        style={style}
        onPressIn={popIn}
        onPressOut={popOut}
        onPress={onPress}
        disabled={disabled}
      >
        {children}
      </Pressable>
    </Animated.View>
  );
}
PressableContainer.propTypes = {
  rootStyle: PropTypes.object,
  additionalTransforms: PropTypes.array,
  accessibilityLabel: PropTypes.string,
  accessibilityRole: PropTypes.string,
  shouldPress: PropTypes.bool,
  style: PropTypes.object,
  onPress: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};
